import { WebCheckInCombinedForm, WebCheckInFormFields } from "./FormOptions";
import { AppInputSwitchProps } from "../AppInputSwitcher/AppInputSwitcher.props";

export type WebCheckFormType = Record<
  keyof WebCheckInCombinedForm,
  AppInputSwitchProps
>;
export const SelfDriverFormFields: Record<
  | "documents"
  | "documentNumber"
  | "licenseType"
  | "releaseDate"
  | "expiryDate"
  | "issuedBy",
  any
> = {
  documents: {
    ...WebCheckInFormFields.documents,
    key: "document",
    placeholder: "Document",
  },
  documentNumber: WebCheckInFormFields.documentNumber,
  licenseType: WebCheckInFormFields.licenseType,
  releaseDate: WebCheckInFormFields.releaseDate,
  expiryDate: WebCheckInFormFields.expiryDate,
  issuedBy: {
    ...WebCheckInFormFields.issuedBy,
  },
};
export const IndividualForm: WebCheckFormType = {
  ...WebCheckInFormFields,
};
export const DriverFormFields = {
  firstName: WebCheckInFormFields.firstName,
  lastName: WebCheckInFormFields.lastName,
  country: WebCheckInFormFields.country,
  city: WebCheckInFormFields.city,
  state: WebCheckInFormFields.state,
  zip: WebCheckInFormFields.zip,
  streetName: WebCheckInFormFields.streetName,
  n: WebCheckInFormFields.n,
  mobileNumber: WebCheckInFormFields.mobileNumber,
  email: WebCheckInFormFields.email,
  birthNation: WebCheckInFormFields.birthNation,
  birthPlace: WebCheckInFormFields.birthPlace,
  birthProv: WebCheckInFormFields.birthProv,
  birthDate: WebCheckInFormFields.birthDate,
  // field1: WebCheckInFormFields.vatNumber,
  gender: WebCheckInFormFields.gender,
  // field2: WebCheckInFormFields.vatNumber,
  ssn: WebCheckInFormFields.ssn,
  documentType: WebCheckInFormFields.documents,
  documentNumber: WebCheckInFormFields.documentNumber,
  licenseType: WebCheckInFormFields.licenseType,
  issuedBy: WebCheckInFormFields.issuedBy,
  releaseDate: WebCheckInFormFields.releaseDate,
  expiryDate: WebCheckInFormFields.expiryDate,
};
